import AnnualReportNoticeSource from "./AnnualReportNoticeSource";

const annualReportTenderMode = (entry, dictTranslations) => {
    if (entry.source === AnnualReportNoticeSource.BZP) {
        return entry.tenderModeBzp ? dictTranslations.tenderModeBzp[entry.tenderModeBzp] : null
    } else if (entry.source === AnnualReportNoticeSource.TED) {
        return entry.tenderModeTed ? dictTranslations.tenderModeTed[entry.tenderModeTed] : null
    }
    return null;
}
export default annualReportTenderMode;